import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import { IconButton } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';

import { Modal, ModalContents, ModalTitle, ModalButton } from 'components/Modal/Modal';

export default class DialogButton extends PureComponent {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleConfirm = async () => {
    await this.props.handleConfirm();
    this.handleRequestClose();
  };

  render() {
    const {
      buttonProps,
      cancelProps,
      confirmProps,
      asLink,
      buttonLabel,
      title,
      text,
      cancelLabel,
      confirmLabel,
      style,
      children,
      iconButton,
      tooltip,
      customButton,
    } = this.props;

    const ButtonLink = customButton ?? (iconButton ? IconButton : asLink ? Link : Button);

    // eslint-disable-next-line no-shadow
    const TooltipComponent = ({ children }) =>
      tooltip ? <Tooltip title={tooltip}>{children}</Tooltip> : <>{children}</>;

    return (
      <div style={style}>
        <TooltipComponent>
          <ButtonLink onClick={this.handleClickOpen} variant="outlined" {...buttonProps}>
            {children || buttonLabel}
          </ButtonLink>
        </TooltipComponent>
        <Modal
          open={this.state.open}
          disableAutoFocus
          onClose={this.handleRequestClose}
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            ...style,
          }}
        >
          <ModalContents
            onClickClose={this.handleRequestClose}
            body={
              <>
                <ModalTitle>{title}</ModalTitle>
                <DialogContentText>{text}</DialogContentText>
              </>
            }
            actions={
              <>
                <ModalButton
                  variant="outlined"
                  onClick={() => {
                    this.handleRequestClose();
                  }}
                  {...cancelProps}
                >
                  {cancelLabel}
                </ModalButton>
                &nbsp;
                <ModalButton
                  type="submit"
                  onClick={() => {
                    this.handleConfirm();
                  }}
                  {...confirmProps}
                >
                  {confirmLabel}
                </ModalButton>
              </>
            }
          />
        </Modal>
      </div>
    );
  }
}

DialogButton.propTypes = {
  style: PropTypes.object,
  buttonLabel: PropTypes.node,
  buttonProps: PropTypes.object,
  title: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  cancelProps: PropTypes.object,
  confirmProps: PropTypes.object,
  handleConfirm: PropTypes.func,
  asLink: PropTypes.bool,
  children: PropTypes.node,
  iconButton: PropTypes.bool,
  tooltip: PropTypes.string,
  customButton: PropTypes.func,
};
